module.exports = __webpack_public_path__ + "img/icon-list-mouse.523e006a.svg";